export enum GlobalSubscriptionRoutes {
  BASE = 'subscription'
}
